// extracted by mini-css-extract-plugin
export default {"mainContainer":"SetName_mainContainer__qNH59","creationContainer":"SetName_creationContainer__sEEz5"};